<ng-container *transloco="let t">
  <ng-container *ngFor="let v of values$ | async">
    <div>
      <label class="mr-1">{{t('alert-mail-report.subject')}}:</label>
      <span class="font-weight-bold">{{v.subject}}</span>
    </div>
    <div>
      <label class="mr-1">{{t('alert-mail-report.message')}}:</label>
      <div class="p-2 message" [innerHtml]="v.message"></div>
    </div>
    <div class="row">
      <div class="col-1">
        <label>{{t('alert-mail-report.addresses')}}:</label>
      </div>
      <div class="col-11 text-left">
        <ul class="m-0 p-0 list-style-none">
          <li *ngFor="let addr of v.addresses">
            <span class="font-weight-bold">{{addr.address}}</span>
            (<small *ngIf="addr.sent">{{t('alert-mail-report.sent')}}</small>
            <small *ngIf="!addr.sent" class="text-danger">{{t('alert-mail-report.notSent')}}</small>)
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
        <label>{{t('alert-mail-report.attachments')}}:</label>
      </div>
      <div class="col-11 text-left">
        <ul class="m-0 p-0 list-style-none">
          <li *ngFor="let att of v.attachments">
            <a target="_blank" [href]="serverUrl + att.path | safe:'resourceUrl'">
              {{att.filename}}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</ng-container>
